import { allRolesIn, type RoleHolder } from './userRoles';

/**
 * TCR-2429 — vai trò NVKD (nhân viên kinh doanh) B2B: những tài khoản ĐƯỢC GHI NHẬN DOANH SỐ
 * trên đơn B2B. Khớp danh sách BE dùng cho `GET /pos/staff?sales_channel=b2b`; đặt ở đây để
 * 3 nơi (ô chọn trên POS, luật mặc định, cảnh báo khoá quyền) không tự viết lại một mảng.
 */
export const B2B_SALES_ROLES = [
  'b2b_sales',
  'b2b_sales_gt',
  'b2b_sales_mt',
  'b2b_sales_gt_mt',
] as const;

/**
 * TCR-2429 — tài khoản đang đăng nhập có phải NVKD B2B thuần không (MỌI vai trò đều là NVKD).
 *
 * Dùng `allRolesIn` (không phải `hasAnyRole`) là cố ý: quản lý/kế toán/owner có kèm một vai trò
 * NVKD vẫn phải tự chọn NVKD trên đơn B2B. Nếu lấy "có bất kỳ vai trò NVKD" thì đúng những tài
 * khoản hay đứng tên đơn (quản lý, owner) sẽ mặc định ghi doanh số cho chính họ — sai người và
 * không ai thấy, vì ô chọn đã có sẵn giá trị.
 */
export function isB2BSalesUser(user: RoleHolder): boolean {
  return allRolesIn(user, B2B_SALES_ROLES);
}

/**
 * TCR-2075 — vai trò NV → vai trò quản lý trực tiếp hợp lệ. PHẢI khớp `MANAGER_ROLES_BY_SUBORDINATE`
 * ở BE (`tcr-erp-be-tenant/src/modules/user/providers/user.service.ts`) — BE mới là nơi chặn (400).
 * Quản lý ECom (`ecom_sales_manager` ↔ `nv_sale_ecom`) là field riêng, không nằm ở đây.
 */
export const MANAGER_ROLES_BY_SUBORDINATE: Readonly<Record<string, readonly string[]>> = {
  b2b_sales: ['b2b_sales_manager'],
  b2b_sales_gt: ['b2b_sales_manager_gt'],
  b2b_sales_mt: ['b2b_sales_manager_mt'],
  b2b_sales_gt_mt: ['b2b_sales_manager_gt', 'b2b_sales_manager_mt', 'b2b_sales_manager'],
  truong_nhom_kd: ['gd_kd'],
};

/** Vai trò quản lý được chọn làm "Quản lý trực tiếp" cho NV mang các vai trò `roles`. */
export function allowedManagerRolesFor(roles: readonly string[]): string[] {
  const out: string[] = [];
  for (const role of roles) {
    for (const manager of MANAGER_ROLES_BY_SUBORDINATE[role] ?? []) {
      if (!out.includes(manager)) out.push(manager);
    }
  }
  return out;
}

/** Vai trò NV mà người mang các vai trò quản lý `managerRoles` quản lý được. */
export function subordinateRolesFor(managerRoles: readonly string[]): string[] {
  return Object.entries(MANAGER_ROLES_BY_SUBORDINATE)
    .filter(([, managers]) => managers.some((m) => managerRoles.includes(m)))
    .map(([subordinate]) => subordinate);
}
